import React from 'react';
import { Card, InputNumber, Select, Table, Typography, Space, Row, Col } from 'antd';
import { FontColorsOutlined, BorderOuterOutlined, EnvironmentOutlined, BookOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export default function AdvancedPanel({ config, onChange }) {
  const tableData = [
    { key: '1', speed: '0-30', lower: '70mm', upper: '100mm', type: 'Urban/Low' },
    { key: '2', speed: '31-50', lower: '100mm', upper: '140mm', type: 'Urban' },
    { key: '3', speed: '51-65', lower: '125mm', upper: '175mm', type: 'SH' },
    { key: '4', speed: '66-80', lower: '175mm', upper: '245mm', type: 'NH' },
    { key: '5', speed: '81-100', lower: '215mm', upper: '300mm', type: 'Expressway' },
    { key: '6', speed: '101-120', lower: '305mm', upper: '425mm', type: 'High-Speed' },
    { key: '7', speed: '121-150', lower: '340mm', upper: '475mm', type: 'Access Ctrl' },
  ];

  const columns = [
    { title: 'Speed', dataIndex: 'speed', key: 'speed', render: (text) => `${text} km/h` },
    { title: 'Lower x', dataIndex: 'lower', key: 'lower' },
    { title: 'Upper x', dataIndex: 'upper', key: 'upper' },
    { title: 'Type', dataIndex: 'type', key: 'type', render: (text) => <Text style={{ color: 'var(--teal)' }}>{text}</Text> },
  ];

  return (
    <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
      {/* Typography */}
      <Card 
        size="small"
        title={
          <Space>
            <FontColorsOutlined />
            <Text strong>Typography (Section 16.3.1)</Text>
          </Space>
        }
        className="section-card"
      >
        <Space orientation="vertical" size="small">
          <Text type="secondary" style={{ fontSize: 12 }}><strong>English Font:</strong> Transport Medium</Text>
          <Text type="secondary" style={{ fontSize: 12 }}><strong>Hindi Font:</strong> Hindi7 / Narad Bold</Text>
        </Space>
      </Card>

      {/* Sign Dimensions */}
      <Card 
        size="small"
        title={
          <Space>
            <BorderOuterOutlined />
            <Text strong>Sign Dimensions (s/w units)</Text>
          </Space>
        }
        className="section-card"
      >
        <Row gutter={12}>
          <Col xs={24} sm={12}>
            <Text type="secondary" style={{ fontSize: 11, display: 'block', marginBottom: 6 }}>Block Height</Text>
            <InputNumber
              min={10}
              max={50}
              step={0.5}
              value={config.block_height_sw ?? 21.5}
              onChange={(value) => onChange({ block_height_sw: value })}
              style={{ width: '100%' }}
              size="large"
            />
          </Col>
          <Col xs={24} sm={12}>
            <Text type="secondary" style={{ fontSize: 11, display: 'block', marginBottom: 6 }}>Gap Between Blocks</Text>
            <InputNumber
              min={0}
              max={10}
              step={0.5}
              value={config.gap_between_blocks_sw ?? 1}
              onChange={(value) => onChange({ gap_between_blocks_sw: value })}
              style={{ width: '100%' }}
              size="large"
            />
          </Col>
          <Col xs={24} sm={12}>
            <Text type="secondary" style={{ fontSize: 11, display: 'block', marginBottom: 6 }}>Padding (Top/Bottom)</Text>
            <InputNumber
              min={0}
              max={10}
              step={0.5}
              value={config.top_bottom_padding_sw ?? 1.5}
              onChange={(value) => onChange({ top_bottom_padding_sw: value })}
              style={{ width: '100%' }}
              size="large"
            />
          </Col>
          <Col xs={24} sm={12}>
            <Text type="secondary" style={{ fontSize: 11, display: 'block', marginBottom: 6 }}>Horizontal Padding</Text>
            <InputNumber
              min={0}
              max={10}
              step={0.5}
              value={config.horizontal_inner_padding_sw ?? 1.5}
              onChange={(value) => onChange({ horizontal_inner_padding_sw: value })}
              style={{ width: '100%' }}
              size="large"
            />
          </Col>
        </Row>
      </Card>

      {/* Siting */}
      <Card 
        size="small"
        title={
          <Space>
            <EnvironmentOutlined />
            <Text strong>Siting (Section 16.3.2.3)</Text>
          </Space>
        }
        className="section-card"
      >
        <Select
          value={config.siting || '750m'}
          onChange={(value) => onChange({ siting: value })}
          style={{ width: '100%' }}
          size="large"
        >
          <Select.Option value="750m">750m - 1.5km from exit (Gantry, first sign)</Select.Option>
          <Select.Option value="250m">250m - 750m from exit (Gantry, second)</Select.Option>
          <Select.Option value="100m">100m ahead of exit (Stack type)</Select.Option>
          <Select.Option value="60m">60m beyond junction (Reassurance)</Select.Option>
        </Select>
      </Card>

      {/* IRC Reference Table */}
      <Card 
        size="small"
        title={
          <Space>
            <BookOutlined />
            <Text strong>Quick Reference</Text>
          </Space>
        }
        className="section-card"
      >
        <Table
          dataSource={tableData}
          columns={columns}
          pagination={false}
          size="small"
          className="reference-table"
        />
      </Card>
    </Space>
  );
}
